import { requestApi } from './Api';

export const getPrescribePractice = (navigate, params) => {
  return requestApi({
    url: '/api/prescribe/getPractice',
    method: 'POST',
    params,
    navigate
  });
};

export const prescribeEnrollPractice = (navigate, params) => {
  return requestApi({
    url: '/api/prescribe/practiceEnroll',
    method: 'POST',
    params,
    navigate
  });
};

export const getEnrolledPractitioners = (navigate, params) => {
  return requestApi({
    url: '/api/prescribe/listPracticeUsers',
    method: 'POST',
    params,
    navigate
  });
};

export const enrollPractitioner = (navigate, params) => {
  return requestApi({
    url: '/api/prescribe/enrollUser',
    method: 'POST',
    params,
    navigate
  });
};

export const unenrollPractitioner = (navigate, params) => {
  return requestApi({
    url: '/api/prescribe/deleteUser',
    method: 'POST',
    params,
    navigate
  });
};
